import { createContext } from 'react';
import restrictions from '@gin-betting/restrictions';
import { noop } from 'lodash';

import { RestrictionsCtx } from './useRestrictions';

const {
    constants: { initialState },
} = restrictions;

export const RestrictionsContext = createContext<RestrictionsCtx>({
    state: initialState,
    dispatchRestrictions: noop,
});
